export enum OrderValidationStatus {
  Pending = 'PENDING',
  Validated = 'VALIDATED',
  Failed = 'FAILED',
}
